import React from "react"
import {observer} from "mobx-react"
import {FormattedMessage, injectIntl} from "react-intl"
import Grid from "@material-ui/core/Grid"
import moment from "moment"

// special import for Material-UI binding
import api from "../../../actions/api"
import XsTableServer from "../../../../../global/ui/xsTableServer/xsTableServer"
import VaccinationListStore from "../../../stores/VaccinationListStore"
import GlobalStore from "../../../../../global/store/GlobalStore"

import VaccinatedFilter from "./vaccinatedFilter"
import ExportVaccinatedListToXlsDialog from "./exportVaccinatedListToXlsDialog"
import UIStore from "../../../stores/UIStore"
import TableStore from "../../../stores/TableStore"

@injectIntl
@observer
export default class VaccinatedList extends React.Component {
	constructor(props) {
		super(props)
		UIStore.isFormSaving = false
	}

	onHandleRowClick = (dataRow) => {
		if (isNotEmpty(dataRow.person_id) && isNotEmpty(dataRow.provider_id)) {
			GlobalStore.changeOrgUnitAndRouteToPatientDetail(dataRow.provider_id, dataRow.person_id)
		}
	}

	render() {
		const applyFilters = VaccinationListStore.vaccFilters

		return (
			<Grid container className="xs-vaccinated-list">
				<VaccinatedFilter />
				<Grid item xs={12}>
					{VaccinationListStore.changedFilters ? (
						<div className="xs-table-no-data pa-3 borderRadius-1 mt-8">
							<i
								className="far fa-search fa-lg mr-3 pointer"
								onClick={() => {
									if (
										TableStore.tables.hasOwnProperty("vaccinationList") &&
										TableStore.tables["vaccinationList"].hasOwnProperty("index")
									) {
										delete TableStore.tables["vaccinationList"]["index"]
									}

									VaccinationListStore.getFiltersVaccinated(VaccinationListStore.vaccinatedFormRef)
								}}
							></i>
							<FormattedMessage id="Common.label.changeFilterSettingsClkickOnTheMagnifyingToApplyThem" />
						</div>
					) : (
						<XsTableServer
							setRef={(table) => (VaccinationListStore.vaccinatedReportListRef = table)}
							uri={api.loadVaccinatedReport().getPath()}
							filterValue={applyFilters}
							white={true}
							orderValue={[
								{
									asc: false,
									associated_column: "created_at"
								}
							]}
							config={{
								columnDefs: {
									recorded_at: {
										title: "Dátum očkovania",
										design: {
											width: "50px",
											body: {
												formatter: (props) => {
													return isNotEmpty(props) ? moment(props).format("DD.MM.YYYY") : ""
												}
											}
										},
										type: "string"
									},
									person_identifier: {
										title: <FormattedMessage id="Patient.labels.IDNumber" />,
										type: "string",
										design: {
											width: "100px",
											body: {
												renderer: (props) => {
													return <div className="blueDark xs-bold">{props.value}</div>
												}
											}
										}
									},
									vaccine_code_ext: {
										title: "Očk. látka",
										type: "action",
										design: {
											width: "100px"
										}
									},
									batch_number: {
										title: "Šarža",
										design: {
											width: "100px"
										}
									},
									vacc_order: {
										title: "Poradie dávky",
										design: {
											width: "100px"
										},
										type: "string"
									},
									user: {
										title: "Používateľ",
										design: {
											width: "200px"
										},
										type: "string"
									}
								},
								options: {
									name: "vaccinationList",
									showCursor: true,
									row_count_full: 100000,
									mapper: (dataRow) => {
										return {
											recorded_at: isSafe(dataRow.recorded_at) ? dataRow.recorded_at : "",
											person_identifier: isSafe(dataRow.person_identifier) ? dataRow.person_identifier : "",
											vaccine_code_ext: isSafe(dataRow.vaccine_code_ext) ? dataRow.vaccine_code_ext : "",
											batch_number: isSafe(dataRow.batch_number) ? dataRow.batch_number : "",
											vacc_order: isSafe(dataRow.vacc_order) ? dataRow.vacc_order : "",
											person_id: dataRow.person_id,
											provider_id: dataRow.provider_id,
											user: dataRow.user_login
										}
									},
									onRowClick: (dataRow) => {
										this.onHandleRowClick(dataRow)
									}
								}
							}}
						/>
					)}
				</Grid>
				<ExportVaccinatedListToXlsDialog />
			</Grid>
		)
	}
}
